module.exports = __webpack_public_path__ + "img/hoods_color.e6dae18a.svg";